import {useMutation, useQueryClient} from "@tanstack/react-query";
import {EventAPI} from "../../services/network/event-api";
import {EVENT_ENDPOINTS, RECOMMENDATION_ENDPOINTS} from "../../services/network/endpoints";
import {IEvent, IEventCreate} from "../../services/models/event";
import {toast} from "react-toastify";
import {RecommendationsApi} from "../../services/network/recommendation-api";

export function useSetReadRecomAndComments() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: [RECOMMENDATION_ENDPOINTS.SET_READ],
        mutationFn: ({ recomID }: { recomID: string}) => RecommendationsApi.setReadRecommendationAndComments(recomID),

        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [RECOMMENDATION_ENDPOINTS.GET_UNREAD_RECOMMS], refetchType: 'all' });
            queryClient.invalidateQueries({ queryKey: [RECOMMENDATION_ENDPOINTS.FETCH_BY_SECTOR], refetchType: 'all' });
            queryClient.invalidateQueries({ queryKey: [RECOMMENDATION_ENDPOINTS.FETCH_SHORT], refetchType: 'all' });
        }
    });
}
